import React, { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { RequireAuth, ForbiddenPage } from '@cincoders/cinnamon';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Links, Roles } from './types/enums';
import FormCovenant from './pages/FormCovenant';
import ProcessTypeForm from './pages/ProcessTypeForm';
import FormProcessPage from './pages/FormProcess';
import apiBack from './services/api';
import Home from './pages/Home';
import PageCin from './components/PageCin';

const CinRoutes: React.FC = () => {
  const { initialized, keycloak } = useKeycloak();

  useEffect(() => {
    apiBack.interceptors.request.use(async config => {
      const configuracao = config.headers;
      if (keycloak.authenticated) {
        if (keycloak.isTokenExpired(30)) {
          try {
            await keycloak.updateToken(30);
          } catch {
            keycloak.clearToken();
          }
        }
        configuracao.Authorization = `Bearer ${keycloak.token}`;
      } else {
        configuracao.Authorization = '';
      }
      return config;
    });
  }, [initialized, keycloak]);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={Links.HOME}
          element={
            <RequireAuth keycloak={keycloak} initialized={initialized} permittedRoles={[Roles.DASH_SIPAC]}>
              <PageCin keycloak={keycloak}>
                <Home />
              </PageCin>
            </RequireAuth>
          }
        />
        <Route
          path={Links.FORBIDDEN}
          element={
            <RequireAuth keycloak={keycloak} initialized={initialized} permittedRoles={[Roles.DASH_SIPAC]}>
              <PageCin keycloak={keycloak}>
                <ForbiddenPage keycloak={keycloak} />
              </PageCin>
            </RequireAuth>
          }
        />
        <Route
          path={Links.COVENANT}
          element={
            <RequireAuth keycloak={keycloak} initialized={initialized} permittedRoles={[Roles.DASH_SIPAC]}>
              <PageCin keycloak={keycloak}>
                <FormCovenant />
              </PageCin>
            </RequireAuth>
          }
        />
        <Route
          path={Links.PROCESS}
          element={
            <RequireAuth keycloak={keycloak} initialized={initialized} permittedRoles={[Roles.DASH_SIPAC]}>
              <PageCin keycloak={keycloak}>
                <FormProcessPage />
              </PageCin>
            </RequireAuth>
          }
        />
        <Route
          path={Links.PROCESS_TYPE_FORM}
          element={
            <RequireAuth keycloak={keycloak} initialized={initialized} permittedRoles={[Roles.DASH_SIPAC]}>
              <PageCin keycloak={keycloak}>
                <ProcessTypeForm />
              </PageCin>
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default CinRoutes;
